import React from "react";
import { rgba } from "polished";
import { Box } from "rebass";
import styled from "styled-components";

const Wrapper = styled(Box)`
  position: relative;
  height: 100%;
  background-color: ${(props) =>
    props.noColor ? "" : props.theme.colors.grey[1]};
  &:not(:lang(ar)) {
    &:before,
    &:after {
      right: 0;
    }
    &:after {
      background: ${(props) =>
        props.noColor
          ? ""
          : props.theme.colors.grey[1] &&
            "linear-gradient(to right, " +
              rgba(props.theme.colors.grey[1], 1) +
              ", " +
              rgba(props.theme.colors.grey[1], 0.75) +
              ")"};
    }
  }
  &:lang(ar) {
    &:before,
    &:after {
      left: 0;
    }
    &:after {
      background: ${(props) =>
        props.noColor
          ? ""
          : props.theme.colors.grey[1] &&
            "linear-gradient(to left, " +
              rgba(props.theme.colors.grey[1], 1) +
              ", " +
              rgba(props.theme.colors.grey[1], 0.75) +
              ")"};
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    max-width: 672px;
    height: 100%;
    background-image: ${(props) => "url(" + props.image + ")"};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    filter: grayscale(1);
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    max-width: 672px;
    height: 100%;
  }
`;

const Container = styled(Box)`
  position: relative;
  z-index: 1;
  height: 100%;
`;

const GradientCard = (props) => (
  <Wrapper
    className={props.className}
    noColor={props.noColor}
    style={props.style}
    image={props.image}
    px={4}
    py={5}
  >
    <Container className="gradient-card__container">{props.children}</Container>
  </Wrapper>
);

GradientCard.defaultProps = {};

export default GradientCard;



// WEBPACK FOOTER //
// ./src/components/GradientCard.js